import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

import Home from '../pages/Home';
import About from '../pages/About';
import LinkedInCallback from '../pages/LinkedInCallback';
import JobList from '../pages/JobList';
import JobDetail from '../pages/JobDetail';
import Profil from '../pages/Profil';
import Ozgecmisim from '../pages/Ozgecmisim';
import Navbar from '../components/Navbar';
import PrivateRoute from '../components/PrivateRoute';
import WelcomeVideoPopup from './WelcomeVideoPopup';


import { GoogleOAuthProvider } from "@react-oauth/google";
import "../styles/App.css";

const App = () => {
  return (
    <GoogleOAuthProvider clientId="137542923351-ecqbv2qo50c50dcoe47cdgmgjr6t9gob.apps.googleusercontent.com">
      <Router>
        <Navbar />
        <WelcomeVideoPopup />
        <Routes>
          {/* Herkese açık sayfalar */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/joblist" element={<JobList />} />
          <Route path="/ilan/:id" element={<JobDetail />} />
          <Route path="/linkedin-callback" element={<LinkedInCallback />} />

          {/* 🔐 Korumalı sayfalar */}
          <Route
            path="/profil"
            element={
              <PrivateRoute>
                <Profil />
              </PrivateRoute>
            }
          />
          <Route
            path="/ozgecmisim"
            element={
              <PrivateRoute>
                <Ozgecmisim />
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </GoogleOAuthProvider>
  );
};

export default App;
